import script from "./GroupMembership.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupMembership.vue?vue&type=script&setup=true&lang=js"

import "./GroupMembership.vue?vue&type=style&index=0&id=67485bb2&lang=css"

const __exports__ = script;

export default __exports__